module.exports = __webpack_public_path__ + "img/portugal-cervical-cancer-female.276e663d.png";